export var initialState = {
  news: [],
  isFetching: false,
  isError: false
};
var news = function news() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var _a;
  var response = (_a = action.data) === null || _a === void 0 ? void 0 : _a.data;
  switch (action.type) {
    case 'REQUEST_NEWS':
      {
        return {
          news: [],
          isFetching: true,
          isError: false
        };
      }
    case 'RECEIVE_NEWS':
      {
        return {
          news: response,
          isFetching: false,
          isError: false
        };
      }
    case 'ERROR_NEWS':
      {
        return {
          news: [],
          isFetching: false,
          isError: true
        };
      }
    default:
      return state;
  }
};
export default news;